document.addEventListener("octane.quiz.questionLoaded", function(event) {
    const wrapperEl = event.detail.quiz_wrapper_element;
    if (!wrapperEl) return;

    const checkboxWrapper = wrapperEl.querySelector('div[data-element*="oct-quiz-consent-checkbox"]');
    if (!checkboxWrapper) return;

    const checkBox = checkboxWrapper.querySelector('input[type="checkbox"]');
    if (!checkBox) return;
    
    checkBox.checked = true;
    checkBox.dispatchEvent(new Event('change', { bubbles: true }));
}, false);